import React from 'react';

export const NeutralRatingIcon = ({ borderClass }: { borderClass?: string }) => {
    return (
        <span className={borderClass}>
            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" fill="none">
                <path d="M17 33c8.837 0 16-7.163 16-16S25.837 1 17 1 1 8.163 1 17s7.163 16 16 16Z" fill="#F1E953" />
                <path
                    d="M22.6 12.2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0ZM13 12.2a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z"
                    fill="#F1E953"
                />
                <path
                    d="M10.6 21.8h12.8m-1.6-9.6h.016m-9.616 0h.016M33 17c0 8.837-7.163 16-16 16S1 25.837 1 17 8.163 1 17 1s16 7.163 16 16Zm-10.4-4.8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Zm-9.6 0a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    );
};
